export default "__VITE_PUBLIC_ASSET__d61ffc1f__"